import {
  confirmSignIn,
  signIn,
  fetchAuthSession,
  getCurrentUser
} from '@aws-amplify/auth';

export const requestEmailOTP = async (email) => {
  try {
    const { nextStep } = await signIn({
      username: email,
      options: {
        authFlowType: 'USER_AUTH',
        preferredChallenge: 'EMAIL_OTP'
      }
    });

    if (nextStep.signInStep !== 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE') {
      throw new Error(`Unexpected step: ${nextStep.signInStep}`);
    }
    return {data:nextStep,error:null};
  } catch (error) {
    // console.error(error);
    throw error
  }
};

export const verifyEmailOTP = async (otpCode) => {
  try {
    const otpResponse = await confirmSignIn({
      challengeResponse: otpCode
    });

    if (otpResponse.nextStep.signInStep === 'DONE') {
      console.log('OTP verified — user is now signed in');
      const session = await fetchAuthSession();
      // console.log(session);
      return { session, user: await getCurrentUser() };
    } else {
      // handle any other intermediate steps if you need to
      throw new Error(
        `Unexpected confirmSignIn step: ${otpResponse.nextStep.signInStep}`
      );
    }
  } catch (err) {
    // console.error('OTP verification failed', err);
    throw err
  }
};
